import React from "react";

const pill = (active, locked = false) => ({
  padding: "6px 12px",
  borderRadius: 999,
  border: `1px solid ${active ? "#2b63b6" : "#2a3444"}`,
  background: active ? "#1c2f4f" : "#101723",
  color: active ? "#e7f1ff" : "#9fb0c2",
  cursor: locked ? "not-allowed" : "pointer",
  boxShadow: active ? "inset 0 0 0 1px #3b82f6" : "none",
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
});

export default function CameraChips({ visible, toggle, showAll }) {
  const selectedCount = (v) => (v.cam41 ? 1 : 0) + (v.chel ? 1 : 0) + (v.pool ? 1 : 0);
  const lastLocked = selectedCount(visible) === 1;

  return (
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
      <button
        style={pill(visible.cam41, lastLocked && visible.cam41)}
        onClick={() => toggle("cam41")}
        disabled={lastLocked && visible.cam41}
        title={lastLocked && visible.cam41 ? "At least one camera must remain selected" : "Toggle 41"}
      >
        {lastLocked && visible.cam41 ? <>41 <span style={{ opacity: 0.8 }}>🔒</span></> : "41"}
      </button>
      <button
        style={pill(visible.chel, lastLocked && visible.chel)}
        onClick={() => toggle("chel")}
        disabled={lastLocked && visible.chel}
        title={lastLocked && visible.chel ? "At least one camera must remain selected" : "Toggle Cheltenham"}
      >
        {lastLocked && visible.chel ? <>Cheltenham <span style={{ opacity: 0.8 }}>🔒</span></> : "Cheltenham"}
      </button>
      <button
        style={pill(visible.pool, lastLocked && visible.pool)}
        onClick={() => toggle("pool")}
        disabled={lastLocked && visible.pool}
        title={lastLocked && visible.pool ? "At least one camera must remain selected" : "Toggle Pool"}
      >
        {lastLocked && visible.pool ? <>Pool <span style={{ opacity: 0.8 }}>🔒</span></> : "Pool"}
      </button>
      <button style={pill(visible.cam41 && visible.chel && visible.pool)} onClick={showAll}>All</button>
    </div>
  );
}
